import { render, staticRenderFns } from "./NdvrVideoPlayer.vue?vue&type=template&id=5514d867&scoped=true&"
import script from "./NdvrVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./NdvrVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./NdvrVideoPlayer.vue?vue&type=style&index=0&id=5514d867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514d867",
  null
  
)

export default component.exports